import Config from '@config';
import {
  SupplyPlannedGasVolumeDailyResult,
  SupplyPlannedGasVolumeMeteringPointsResult,
  SupplyPlannedGasVolumeMonthly,
} from '@gasbi/shared/web';
import { createApi } from '@reduxjs/toolkit/query/react';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

export const plannedGasVolumesApi = createApi({
  reducerPath: 'plannedGasVolumesApi',
  baseQuery: axiosBaseQuery({ baseUrl: Config.VITE_API_URL }),
  tagTypes: [
    'PlannedGasVolumeMonthly',
    'PlannedGasVolumeMeteringPoints',
    'PlannedGasVolumeDaily',
  ],
  endpoints: builder => ({
    getMonthlyPlannedGasVolumes: builder.query<
      SupplyPlannedGasVolumeMonthly[],
      { contractId: string; year: number; meteringPointId?: string }
    >({
      query: ({ contractId, year, meteringPointId }) => ({
        url: `/planned-gas-volumes/contracts/${contractId}/monthly`,
        method: 'GET',
        params: { year, meteringPointId },
      }),
      providesTags: ['PlannedGasVolumeMonthly'],
    }),
    getMeteringPointPlannedGasVolumes: builder.query<
      SupplyPlannedGasVolumeMeteringPointsResult,
      { contractId: string; year: number; month: number }
    >({
      query: ({ contractId, year, month }) => ({
        url: `/planned-gas-volumes/contracts/${contractId}/metering-points`,
        method: 'GET',
        params: { year, month },
      }),
      providesTags: ['PlannedGasVolumeMeteringPoints'],
    }),
    getDailyPlannedGasVolumes: builder.query<
      SupplyPlannedGasVolumeDailyResult,
      {
        contractId: string;
        meteringPointId: string;
        year: number;
        month: number;
      }
    >({
      query: ({ contractId, meteringPointId, year, month }) => ({
        url: `/planned-gas-volumes/contracts/${contractId}/metering-points/${meteringPointId}/daily`,
        method: 'GET',
        params: { year, month },
      }),
      providesTags: ['PlannedGasVolumeDaily'],
    }),
  }),
});

export const {
  useGetMonthlyPlannedGasVolumesQuery,
  useGetMeteringPointPlannedGasVolumesQuery,
  useGetDailyPlannedGasVolumesQuery,
} = plannedGasVolumesApi;
